import React from "react"
import Contact from "../contact/contact"
import { FormspreeProvider } from "@formspree/react"
import instagramLogo from "../../images/instagram-v2.svg"
import footerLogo from "../../images/flex-logo-footer-v2.svg"

import styles from "./newsletter.module.css"

const Footer = () => {
  return (
    <div className={styles.Footer}>
      <div className={styles.Wrapper}>
        <FormspreeProvider project="1590228728829443903">
          <Contact />
        </FormspreeProvider>
        <div className={styles.Socials}>
          <p>Follow us on Instagram!</p>

          <a
            href="https://www.instagram.com/weflex.fit/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={instagramLogo}
              alt="Instagram logo"
              className={styles.Logo}
            />
          </a>
        </div>
      </div>
      <div className={styles.FooterLogo}>
        <img src={footerLogo} alt="Flex footer logo" />
      </div>
      <p className={styles.Copyright}>
        Copyright © 2021 Flex. All rights reserved.
      </p>
    </div>
  )
}

export default Footer
